import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography/Typography';
import Button from '@material-ui/core/Button';
import firebase from 'firebase/app';
import 'firebase/auth';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import Snackbar from '@material-ui/core/Snackbar';

import './Login.css';
import styles from './Login.style';
import { auth } from '../../utilities/firebase-config';
import SnackbarContentWrapper from '../../Components/SnackbarContentWrapper/SnackbarContentWrapper';

class Login extends Component {
  state = {
    email: '',
    emailError: false,
    generalError: false,
    loggingIn: false,
    password: '',
    snackbar: {
      message: '',
      open: false,
      variant: 'success',
    },
    submittingPasswordReset: false,
  };

  changeField = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      emailError: false,
      generalError: false,
    });
  };

  closeSnackbar = () => {
    const { snackbar } = this.state;

    this.setState({
      snackbar: {
        ...snackbar,
        open: false,
      },
    });
  };

  forgotPassword = () => {
    const { email } = this.state;

    if (email) {
      this.setState({
        submittingPasswordReset: true,
      });

      auth.sendPasswordResetEmail(email)
        .then(() => {
          this.setState({
            snackbar: {
              message: 'A password reset link will be sent to your email address',
              open: true,
              variant: 'success',
            },
          });
        })
        .catch((err) => {
          if (err) {
            let message;
            switch (err.code) {
              case 'auth/invalid-email':
                message = 'Please enter a valid email address';
                break;
              case 'auth/user-not-found':
                message = 'This is not a registered email address';
                break;
              default:
                message = 'Unable to request password reset at this time';
            }

            this.setState({
              snackbar: {
                message,
                open: true,
                variant: 'error',
              },
            });
          }
        })
        .finally(() => {
          this.setState({
            submittingPasswordReset: false,
          });
        });
    } else {
      this.setState({
        snackbar: {
          message: 'Please enter an email address for the password reset info to be sent to',
          open: true,
          variant: 'error',
        },
      });
    }
  }

  login = (event) => {
    event.preventDefault();
    this.setState({
      loggingIn: true,
    });
    const { email, password } = this.state;
    firebase.auth().signInWithEmailAndPassword(
      email, password,
    )
      .catch((err) => {
        switch (err.code) {
          case 'auth/invalid-email':
            this.setState({
              emailError: true,
            });
            break;
          default:
            this.setState({
              generalError: true,
            });
            break;
        }
      })
      .finally(() => {
        this.setState({
          loggingIn: false,
        });
      });
  };

  render() {
    const { classes } = this.props;
    const {
      email,
      emailError,
      generalError,
      loggingIn,
      password,
      snackbar,
      submittingPasswordReset,
    } = this.state;

    return (
      <div className="Login container">

        <AppBar position="fixed" color="primary">
          <Toolbar>
            <Typography variant="h6" color="inherit">
              CCARES
            </Typography>
          </Toolbar>
        </AppBar>

        <Typography gutterBottom variant="h5" component="h2">
          Login
        </Typography>

        <form onSubmit={ this.login } name="login">

          <TextField
            id="email"
            name="email"
            label="Email Address"
            className={ classes.textField }
            value={ email }
            onChange={ this.changeField }
            margin="normal"
            type="email"
          />

          { emailError
          && <div className={ classes.error }>Please enter a valid email address</div>
          }

          <TextField
            id="password"
            name="password"
            label="Password"
            className={ classes.textField }
            value={ password }
            onChange={ this.changeField }
            margin="normal"
            type="password"
          />

          { generalError
          && <div className={ classes.error }>Incorrect login information provided</div>
          }

          <Button
            variant="outlined"
            color="primary"
            className={ classes.button }
            onClick={ this.login }
            type="submit"
            disabled={ loggingIn }
          >
            Login
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            className={ classes.button }
            onClick={ this.forgotPassword }
            disabled={ submittingPasswordReset }
          >
            Forgot Password
          </Button>
        </form>

        <Snackbar
          anchorOrigin={ {
            horizontal: 'left',
            vertical: 'bottom',
          } }
          open={ snackbar.open }
          autoHideDuration={ 5000 }
          onClose={ this.closeSnackbar }
        >
          <SnackbarContentWrapper
            onClose={ this.closeSnackbar }
            variant={ snackbar.variant }
            message={ snackbar.message }
          />
        </Snackbar>

      </div>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);
